import {TextField} from "@mui/material";
import {SurveyQuestionType} from "crqlar-react-common/dist/models/survey/survey.model";
import {SurveyInputPurpose} from "crqlar-react-common/dist/models/survey/surveyQuestion.model";
import React, {useState} from "react";
import {RunnerQuestionProps} from "./runnerQuestion.types";
import {surveyMarkdownToPlainText} from "../../shared/surveyMarkdownText.util";

function TextQuestion({question, localize, value, onAnswerChange}: RunnerQuestionProps) {
    const [localText, setLocalText] = useState('');

    const text = value?.textValue ?? localText;

    const write = (next: string) => {
        setLocalText(next);
        onAnswerChange?.({...value, textValue: next});
    };

    const placeholder = localize(question.placeholder);
    const ariaLabel = surveyMarkdownToPlainText(localize(question.title));

    if (question.type === SurveyQuestionType.LONG_TEXT) {
        return (
            <TextField
                fullWidth
                required={!!question.isRequired}
                multiline
                minRows={4}
                value={text}
                onChange={(event) => write(event.target.value)}
                placeholder={placeholder}
                inputProps={{'aria-label': ariaLabel}}
            />
        );
    }

    const email = question.inputPurpose === SurveyInputPurpose.EMAIL;
    const phone = question.inputPurpose === SurveyInputPurpose.PHONE;

    return (
        <TextField
            fullWidth
            required={!!question.isRequired}
            type={email ? 'email' : phone ? 'tel' : 'text'}
            value={text}
            onChange={(event) => write(event.target.value)}
            placeholder={placeholder}
            inputProps={{inputMode: email ? 'email' : phone ? 'tel' : 'text', 'aria-label': ariaLabel}}
        />
    );
}

export default TextQuestion;
